import { Component, OnInit } from '@angular/core';

import { TextFieldComponent } from './text-field.component'

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class SearchFieldComponent extends TextFieldComponent {

  debounce: number = 400;

}



// WEBPACK FOOTER //
// ./src/app/forms/search-field.component.ts